export default "__VITE_ASSET__DlUWxY20__"